import { z } from "zod";
import { errors } from "../errors/errors";

export const language = z.union([
  z.literal("ko"),
  z.literal("sk"),
  z.literal("en"),
]);
export type Language = z.infer<typeof language>;

export const dietaryPreference = z.union([
  z.literal("vegan"),
  z.literal("vegetarian"),
  z.literal("none"),
  z.literal("other"),
]);

export const shortText = z
  .string()
  .min(1, errors.required)
  .max(50, errors.max50);

export const mediumText = z
  .string()
  .min(1, errors.required)
  .max(100, errors.max100);

export const longText = z
  .string()
  .min(1, errors.required)
  .max(1000, errors.max1000);

export const optionalShortText = z.string().max(50, errors.max50).nullable();
export const optionalMediumText = z.string().max(100, errors.max100).nullable();
export const optionalLongText = z.string().max(1000, errors.max50).nullable();

export const person = z.object({
  firstName: shortText,
  lastName: shortText,
  nametag: optionalMediumText,
  dietaryPreference: dietaryPreference,
  dietaryExtra: optionalLongText,
});
export type Person = z.infer<typeof person>;

export const rsvpGuests = z.object({
  primary: person,
  partner: person.nullable(),
  confirmed: z.boolean().nullable(),
  personalizedInfo: optionalLongText,
  email: optionalMediumText,
  roomAssigned: z.boolean(),
  roomConfirmed: z.boolean().nullable(),
});
export type RsvpGuests = z.infer<typeof rsvpGuests>;

export const rsvpGetResponse = z.object({
  guests: rsvpGuests,
  languagePreference: language,
});
export type RsvpGetResponse = z.infer<typeof rsvpGetResponse>;

export const rsvpPatchGuests = z.object({
  primary: rsvpGuests.shape.primary.pick({
    nametag: true,
    dietaryPreference: true,
    dietaryExtra: true,
  }),
  partner: rsvpGuests.shape.partner,
  confirmed: rsvpGuests.shape.confirmed.unwrap(),
  email: rsvpGuests.shape.email,
  roomConfirmed: rsvpGuests.shape.roomConfirmed,
});

export const rsvpPatchRequest = z.object({
  guests: rsvpPatchGuests.optional(),
  languagePreference: language,
});
export type RsvpPatchRequest = z.infer<typeof rsvpPatchRequest>;
